import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';

/**
 * NFR-7: i18n scaffolding from day one. The app ships English-only, but there
 * are no hard-coded user-facing strings, so Arabic is a translation file plus a
 * `dir` flip, not a refactor. `dir` is applied here so RTL works the moment an
 * RTL locale is added.
 */

export const SUPPORTED_LOCALES = ['en', 'ar'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

const RTL_LOCALES: Locale[] = ['ar'];

export function isRtl(locale: string): boolean {
  return RTL_LOCALES.includes(locale as Locale);
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    // Arabic intentionally absent for launch; adding ar.json here is the whole
    // change required, because the layout already uses logical properties.
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

/** Keeps the document's lang/dir in step with the active locale. */
export function applyDocumentLocale(locale: string) {
  document.documentElement.lang = locale;
  document.documentElement.dir = isRtl(locale) ? 'rtl' : 'ltr';
}

applyDocumentLocale(i18n.language);
i18n.on('languageChanged', applyDocumentLocale);

export default i18n;
